// Sidebar → map position hover: the pointer on a step bar, a profile or the drawer's
// lanes plot as a distance along the way, and the range of the section, band or
// lane stretch under it (their `data-start` / `data-end`).
export const TRACK_SELECTOR = ".fe-bar, .fe-profile, .fe-dlplot";
export const RANGE_SELECTOR = "[data-start][data-end]";

/**
 * @param {{left: number, width: number}} rect the track's box
 * @param {number} clientX
 * @param {number} axisCm the track's `data-axis`
 * @returns {number} cm along the way, clamped to the track
 */
export function trackPosition(rect, clientX, axisCm) {
  if (!(rect.width > 0)) return 0;
  const fraction = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
  return Math.round(fraction * axisCm);
}

/** @returns {{startCm: number, endCm: number}|null} from a `data-start`/`data-end` dataset */
export function rangeOf(dataset) {
  const startCm = Number(dataset?.start);
  const endCm = Number(dataset?.end);
  if (dataset?.start === undefined || dataset?.end === undefined) return null;
  if (!Number.isFinite(startCm) || !Number.isFinite(endCm)) return null;
  return { startCm, endCm };
}
